import { VehicleImage } from './vehicle_image'

export { VehicleImage } from './vehicle_image'
export default VehicleImage